import types from 'actions/types'
import Immutable from 'seamless-immutable'
import { combineReducers } from 'redux'
import { SEARCH_BLOCKS } from 'helpers/constants'

const createSearchBlockReducer = (key) => combineReducers({

  fetching: (state = Immutable(false), action) => {
    switch (action.type) {
      case types.SEARCH_START:
        if (action.key === key) {
          return Immutable(true)
        }
        return state
      case types.SEARCH_SUCCESS:
      case types.SEARCH_FAILURE:
        if (action.key === key) {
          return Immutable(false)
        }
        return state
      default: return state
    }
  },

  // The search result
  data: (state = [], action) => {
    switch (action.type) {
      case types.SEARCH_SUCCESS:
        if (action.key === key) {
          return action.data || state // retains data even if not searched
        }
        return state
      case types.SEARCH_CANCEL:
        return state
      case types.SEARCH_CLEAR:
        return []
      default: return state
    }
  },

  limit: (state = 30, action) => {
    switch (action.type) {
      case types.SEARCH_ATTEMPT:
        if (action.key === key) {
          return action.limit || state
        }
      case types.SEARCH_CANCEL:
      case types.SEARCH_CLEAR:
        return 30
      default:
        return state
    }
  },

  count: (state = 0, action) => {
    switch (action.type) {
      case types.SEARCH_SUCCESS:
        if (action.key === key) {
          return action.count
        }
        return state
      case types.SEARCH_CANCEL:
        return state
      case types.SEARCH_CLEAR:
        return 0
      default: return state
    }
  },
})

const visible = (state = false, action) => {
  switch (action.type) {
    case types.SEARCH_CLEAR:
    case types.SEARCH_RESULT_CLICK:
    case types.SEARCH_CANCEL: return false
    case types.SEARCH_FOCUSED: return true
    default: return state
  }
}

const searched = (state = null, action) => {
  switch (action.type) {
    case types.SEARCH_ATTEMPT: return action.phrase
    case types.SEARCH_CANCEL: return null
    case types.SEARCH_CLEAR: return null
    default: return state
  }
}

const history = (state = [], action) => {
  switch (action.type) {
    case types.SEARCH_CANCEL:
      if (action.phrase && action.phrase.length > 0) {
        return [action.phrase, ...state.slice(0, 9)]
      }
      return state
    default: return state
  }
}

const error = (state = null, action) => {
  switch (action.type) {
    case types.SEARCH_ATTEMPT:
    case types.SEARCH_SUCCESS: return null
    case types.SEARCH_FAILURE: return action.error
    default: return state
  }
}

const errorCode = (state = null, action) => {
  switch (action.type) {
    case types.SEARCH_ATTEMPT:
    case types.SEARCH_SUCCESS: return null
    case types.SEARCH_FAILURE: return action.code
    default: return state
  }
}

const searchBlocks = SEARCH_BLOCKS.reduce((ret, current) => {
  ret[current] = createSearchBlockReducer(current)
  return ret
}, {})

export default combineReducers({
  visible,
  searched,
  history,
  error,
  errorCode,
  ...searchBlocks,
})
